import { createContext } from "react";
import { SubscriptionPlanModuleId } from "@jugl-web/rest-api";

export interface ModuleInfoContextValue {
  showModuleInfo: ({
    moduleId,
    isShowcase,
    showConfetti,
  }: {
    moduleId: SubscriptionPlanModuleId;
    isShowcase?: boolean;
    showConfetti?: boolean;
  }) => void;
}

export const ModuleInfoContext = createContext<ModuleInfoContextValue | null>(
  null
);
